
import { Payment } from "./types";
import { FamilyPaymentService } from "./retrievalServices/familyPaymentService";
import { OrganizationPaymentService } from "./retrievalServices/organizationPaymentService";
import { PaymentCacheService } from "./retrievalServices/paymentCacheService";

/**
 * Combined service for retrieving payment data
 */
export const PaymentRetrievalService = {
  /**
   * Get payments for a specific family with pagination support
   */
  getPaymentsForFamily: FamilyPaymentService.getPaymentsForFamily,

  /**
   * Get all payments for an organization with pagination and filtering
   */
  getPaymentsForOrganization: OrganizationPaymentService.getPaymentsForOrganization,

  /**
   * Get a specific payment by ID
   */
  getPaymentById: OrganizationPaymentService.getPaymentById,

  /**
   * Get family payments without using RPC (temporary solution)
   */
  getFamilyPayments: FamilyPaymentService.getFamilyPayments,

  /**
   * Get recent payments for a family
   */
  getRecentPayments: FamilyPaymentService.getRecentPayments,

  /**
   * Clear payment cache for specific family, organization, or all
   */
  clearCache: PaymentCacheService.clearCache
};
